import React, {useState} from 'react'

import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {useCalcContext} from "../../contexts/CalcContext";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from "@mui/material/Divider";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {LEASE_DEAL_LIGHT, PURCHASE_DEAL_DARK} from "../../contexts/DealContext";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import Switch from "@mui/material/Switch";
import classnames from "classnames";
import Button from "@mui/material/Button";


const nextYear = new Date().getFullYear() + 1
const allYears = Array.from({ length: nextYear - 2015 + 1 }, (_, i) => String(2015 + i));
const newYears = allYears.slice(-3)

export const CalcSelectCar = () => {
    const {
        carState,
        setCarState,
        getMakesForYear,
        getMakesForYearResponse,
        getModelsForMake,
        getModelsForMakeResponse,
        getTrimsForModelResponse,
        getTrimsForModel,
        getCarByVinResponse,
        calcState,
        setCalcState,
        isUsed,
        setIsUsed,
    } = useCalcContext()

    const [isTrimSelectOpen, setIsTrimSelectOpen] = useState(false)

    const getIcon = (isLoading, props) => {
        const isFullLoading = getCarByVinResponse?.loading || isLoading
        return isFullLoading ? <CircularProgress {...props} size={13} style={{marginRight: '6px', marginTop: '3px'}}/> :
            <ArrowDropDownIcon {...props}/>
    }

    useDidMountEffect(function openTrimSelectIfMultipleCars(){
        if (carState.vin_vehicles.length > 1) {
            setIsTrimSelectOpen(true)
        }
    }, [carState.vin_vehicles])

    const isTrimInVinVehicles = (trimId) => {
        const vinVechileIds = carState.vin_vehicles.map(v => String(v.id))
        return vinVechileIds.includes(String(trimId))
    }

    const isRebatesDisabled = !calcState.base_car_id || !calcState.location_id || !calcState.dealer_location_id

    const { makes, models, trims, options } = carState

    const years = isUsed ? allYears : newYears

    return (
        <Box className={'CalcPageInfo_box'}>
            <Stack
                direction={'column'}
                justifyContent="space-between"
                style={{
                    height: '100%'
                }}
            >
                <div>
                    <Stack
                        style={{ width: '100%' }}
                        direction={'row'}
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography
                            variant="h6"
                            component="div"
                            className={'header location-info'}
                        >
                            <DirectionsCarFilledOutlinedIcon sx={{color: '#2267CE'}}/>
                            <span>
                            Select Car
                        </span>
                        </Typography>
                        <Typography
                            component="div"
                            className={'header location-info'}
                            style={{
                                fontSize: '12px',
                            }}
                        >
                            <label style={{ fontWeight: isUsed ? 500 : 200}}>Used</label>
                            <Switch
                                label="Used"
                                checked={isUsed}
                                onChange={() => {
                                    setIsUsed(!isUsed)
                                }}
                            />
                        </Typography>

                    </Stack>
                    <Divider className={'divider'} sx={{ marginBottom: '10px'}}/>
                    <Typography
                        variant="h5"
                        component="div"
                        className={'header-title'}
                        sx={{
                            fontSize: '24px',
                            fontWeight: 'bold',
                        }}
                    >
                        <div className={'select-row'}>
                            <label>Year</label>
                            <Select
                                className={'Select'}
                                labelId="pricing-select-year"
                                id="year-select"
                                value={carState.year}
                                label="Year"
                                IconComponent={(props) => getIcon(false, props)}
                                onChange={(e) => {
                                    const year = e.target.value
                                    setCarState({
                                        ...carState,
                                        year: year,
                                        make: '',
                                        model: '',
                                        trim: '',
                                        options: []
                                    })

                                    setCalcState({...calcState, vin: ''})

                                    getMakesForYear(isUsed)
                                }}
                            >
                                {
                                    years.map((year) => <MenuItem key={year} value={year}>{year}</MenuItem>)
                                }
                            </Select>
                        </div>
                        <div className={'select-row'}>
                            <label>Make</label>
                            <Select
                                className={'Select'}
                                IconComponent={(props) => getIcon(getMakesForYearResponse?.loading, props)}
                                value={carState.make}
                                disabled={!carState.year || ! carState.makes.length}
                                onChange={(e) => {
                                    const make = e.target.value
                                    setCarState({
                                        ...carState,
                                        make: make,
                                        model: '',
                                        trim: '',
                                        options: []
                                    })
                                    setCalcState({...calcState, vin: ''})

                                    getModelsForMake(carState.year, make, isUsed)
                                }}
                            >
                                {
                                    makes.map((make) => <MenuItem key={make.cleaned_name} value={make.cleaned_name}>{make.cleaned_name}</MenuItem>)
                                }
                            </Select>
                        </div>
                        <div className={'select-row'}>
                            <label>Model</label>
                            <Select
                                className={'Select'}
                                IconComponent={(props) => getIcon(getModelsForMakeResponse?.loading, props)}
                                value={carState.model}
                                disabled={!carState.make || ! carState.models.length}
                                onChange={(e) => {
                                    const model = e.target.value
                                    setCarState({
                                        ...carState,
                                        model: model,
                                        trim: '',
                                        options: []
                                    })

                                    setCalcState({...calcState, vin: ''})
                                    getTrimsForModel(carState.year, carState.make, model, isUsed)
                                }}
                            >
                                {
                                    models?.map((model) => <MenuItem key={model.name} value={model.cleaned_name}>{model.cleaned_name}</MenuItem>)
                                }
                            </Select>
                        </div>
                        <div className={'select-row'}>
                            <label>Trim</label>
                            <Select
                                className={'Select'}
                                value={carState.trim}
                                onClose={() => setIsTrimSelectOpen(false)}
                                onOpen={() => setIsTrimSelectOpen(true)}
                                open={isTrimSelectOpen}
                                disabled={!carState.model|| ! carState.trims.length}
                                IconComponent={(props) => getIcon(getTrimsForModelResponse?.loading, props)}
                                onChange={(e) => {
                                    const trim = JSON.parse(e.target.value)
                                    const last_deal_data = trim.last_deal_data

                                    setCarState({
                                        ...carState,
                                        trim: JSON.stringify(trim),
                                        options: trim.option_codes,
                                        car_id: trim.id,
                                        base_car_id: trim.id,
                                    })

                                    setCalcState({
                                        ...calcState,
                                        car_id: trim.id,
                                        base_car_id: trim.id,
                                        msrp: last_deal_data?.msrp,
                                        cost: last_deal_data?.cost,
                                        // profit: last_deal_data?.profit,
                                        // vin: '',
                                    })
                                    setTimeout(() => {
                                        setIsTrimSelectOpen(false)
                                    }, 0)

                                }}
                            >
                                {
                                    trims?.map((trim) =>
                                        <MenuItem
                                            key={trim.id}
                                            value={JSON.stringify(trim)}
                                            sx={{
                                                backgroundColor: isTrimInVinVehicles(trim.id) ? "rgba(0, 0, 0, 0.04)" : "inherit"
                                            }}
                                        >
                                            {trim.name}<span style={{fontSize: '11px', marginLeft: '5px'}}> [{trim.manufacture_code}]</span>
                                        </MenuItem>)
                                }
                            </Select>
                        </div>
                        {
                            Boolean(carState.options.length) &&
                            <div className={'select-row'}>
                                <Tooltip
                                    title={'Option codes are not necessary but can affect rebates.'}
                                    arrow placement={'right'}
                                >
                                    <label>
                                        Options
                                        <InfoOutlinedIcon
                                            sx={{
                                                color: LEASE_DEAL_LIGHT,
                                                fontSize: '19px',
                                                marginLeft: '5px'
                                            }}
                                        />
                                    </label>
                                </Tooltip>
                                <Select
                                    className={'Select'}
                                    multiple={true}
                                    IconComponent={(props) => getIcon(getModelsForMakeResponse?.loading, props)}
                                    value={carState.option_codes}
                                    disabled={!carState.make || !carState.models.length || !carState.trims.length}
                                    onChange={(e) => {
                                        const option_codes = e.target.value
                                        setCarState({
                                            ...carState,
                                            option_codes: option_codes
                                        })
                                        const option_code_ids = option_codes.map(c => c.id)

                                        setCalcState({...calcState, option_code_ids: option_code_ids})
                                    }}
                                >
                                    {
                                        options?.map((option) => <MenuItem key={option.id} value={option}>{option.name}</MenuItem>)
                                    }
                                </Select>
                            </div>

                        }

                        <Divider
                            sx={{
                                margin: '10px 0px',
                                fontSize: '10px'
                            }}
                        >
                            Or
                        </Divider>
                        <div className={'select-row'}>
                            <label>
                                Vin
                            </label>
                            <Input
                                className={''}
                                type="text"
                                value={calcState.vin}
                                placeholder={'Enter a Vin'}
                                onChange={(e) => {
                                    setCalcState({...calcState, vin: e.target.value})
                                }}
                            />
                        </div>
                    </Typography>
                </div>
            </Stack>
        </Box>
    )
}